import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { IconType } from '@aibees/shared/components';
import { RefObject } from 'react';

export interface ContactDetailsProps {
  className?: string;
}

export enum ContactDetailsSliderTabTitle {
  Work_History = 'Work History',
  Education = 'Education',
  Publications = 'Publications',
  Volunteer = 'Volunteer',
  Certification = 'Certification',
  Projects = 'Projects',
  Recommendations = 'Recommendations',
  Language = 'Languages',
}

export enum REF_NAMES {
  workHistoryRef = 'workHistoryRef',
  publicationsRef = 'publicationsRef',
  volunteerRef = 'volunteerRef',
  certificationRef = 'certificationRef',
  projectsRef = 'projectsRef',
  educationRef = 'educationRef',
  recommendationsRef = 'recommendationsRef',
  languagesRef = 'languagesRef',
}

export type TabsRefNameMapperType = {
  [value in ContactDetailsSliderTabTitle]: REF_NAMES;
};

export type RefNames = {
  [key in REF_NAMES]: RefObject<HTMLDivElement>;
};

export type TabsUpdatesMapperType = {
  [value in ContactDetailsSliderTabTitle]: PersonContactDetailsItem;
};

export type PeopleContactDetailItem = {
  value: string;
  label: ContactDetailsSliderTabTitle;
  key: ContactDetailsSliderTabTitle;
  disabled?: boolean;
  icon?: IconType;
};
